import React from 'react'
import Button from '@components/atoms/Button'

interface LoadMoreButtonProps {
  onLoadMore: () => void
  productsToShow: number
  totalProducts: number
}

const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({ onLoadMore, productsToShow, totalProducts }) => {
  const isLoadable = productsToShow < totalProducts
  const progressPercentage = Math.min((productsToShow / totalProducts) * 100, 100) // Ensure it doesn't exceed 100%

  return (
    <div className="mt-6 flex flex-col items-center gap-4">
      {/* Load More Button */}
      {isLoadable && (
        <Button
          mode="button"
          buttonText={window.DEPT.Strings.filters.moreLoads}
          onClick={onLoadMore}
        />
      )}

      {/* Progress Bar */}
      <div className="mt-5 w-full flex justify-center">
        <div className="w-72 h-2 bg-gradient-secondary rounded">
          <div
            className="h-full bg-gradient-primary rounded"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>

      {/* Progress Status */}
      <div className="text-center body-sm font-medium text-black">
        Showing {productsToShow} of {totalProducts} Products
      </div>
    </div>
  )
}

export default LoadMoreButton
